// extracted by mini-css-extract-plugin
export default {"record":"NewRecord_record__FUd+a","numRecord":"NewRecord_numRecord__cYg7n","comma":"NewRecord_comma__OL+Qj"};